import React, { useState, useEffect } from 'react';
import { X, Eye, Search, Calendar } from "lucide-react";
import { useSelector } from "react-redux";
import Loading from "../../component/Loading/Loading";
import Pagination from '../../utils/Pagenation/Pagenation';
import { Link } from "react-router-dom";
import useAxiosInstance from '../../services/useAxiosInstance';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

const PaymentsDetails = () => {
  console.log("gdf");

  const axiosInstance = useAxiosInstance();
  const [data, setData] = useState([]);
  const [showCommunityForm, setShowCommunityForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [activeTab, setActiveTab] = useState('Pending');
  const itemsPerPage = 5;
  const communityId = useSelector((state) => state.auth.communityId);
  const userId = useSelector((state) => state.auth.userId);
  const clientId = useSelector((state) => state.auth.clientId);
  const [loading, setLoading] = useState(false);
  const [clearBtnshow, setClearBtnshow] = useState(false);
  const roleId = useSelector((state) => state.auth.roleId);

  console.log(communityId);
  console.log(clientId);
  let requestedClientIdget;
  if (roleId === 1001 || roleId === 1002) {
    requestedClientIdget = 0;
  } else if (roleId === 1003) {
    requestedClientIdget = clientId;
  }
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getLastMonthDate = () => {
    const today = new Date();
    const lastMonthDate = new Date(today);
    lastMonthDate.setMonth(today.getMonth() - 1);

    return lastMonthDate.toISOString().split('T')[0];
  };

  const [startDate, setStartDate] = useState(getTodayDate());
  const [endDate, setEndDate] = useState(getLastMonthDate());
  const [filterType, setFilterType] = useState([]);


  console.log(startDate);
  console.log(endDate);

  const [filterData, setFilterData] = useState({
    startDates: getTodayDate(),
    endDates: getLastMonthDate(),
  });

  const handleStartDateChange = (event) => {
    setFilterData({
      ...filterData,
      startDates: event.target.value
    });
  };

  const handleEndDateChange = (event) => {
    setFilterData({
      ...filterData,
      endDates: event.target.value
    });
  };

  const handlePaymentStatusChange = (event) => {
    setFilterData({
      ...filterData,
      filterType: event.target.value
    });
  };

  const handleSearchChange = () => {
    setStartDate(filterData.startDates);
    setEndDate(filterData.endDates);
    setFilterType(filterData.filterType);
    setCurrentPage(0);
    setClearBtnshow(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      console.log(activeTab);

      try {
        const response = await axiosInstance.get(
          `/api/public/paymentdetail/CommunityIdAndClientId`,
          {
            params: {
              clientId: requestedClientIdget,
              communityId: communityId,
              startDate: startDate,
              endDate: endDate,
              paymentStatus: activeTab,
              filterType: filterType,
            }
          }
        );
        setData(response.data);
        console.log(response.data);

      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, [communityId, requestedClientIdget, startDate, endDate, activeTab, filterType]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
    setCurrentPage(0);
  };

  const clearFilters = () => {
    setStartDate(getTodayDate());
    setEndDate(getLastMonthDate());
    setFilterData({
      startDates: getTodayDate(),
      endDates: getLastMonthDate(),
    });
    setFilterType([]);
    setSelectedPayments([]);
    setActiveTab('Pending');
    setClearBtnshow(false);
    console.log("clear", startDate, endDate);
  };


  const handleViewMore = async (paymentDetailId) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/api/public/paymentdetail/getPaymentDetailById/${paymentDetailId}`);
      setSelectedPayment(response.data);
      setShowCommunityForm(true);
    } catch (error) {
      console.error('Error fetching payment details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (item) => {
    let updatedSelectedPayments = [...selectedPayments];
    let updatedTotalAmount = totalAmount;

    if (updatedSelectedPayments.includes(item)) {
      updatedSelectedPayments = updatedSelectedPayments.filter(
        payment => payment !== item
      );
      updatedTotalAmount -= item.amount;
    } else {
      updatedSelectedPayments.push(item);
      updatedTotalAmount += item.amount;
    }

    setSelectedPayments(updatedSelectedPayments);
    setTotalAmount(updatedTotalAmount);
  };

  const filteredData = data.filter(item =>
    (item.clientName.toLowerCase().includes(searchQuery))
  );

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const handleCloseModal = () => {
    setShowCommunityForm(false);
    setSelectedPayment(null);
  };

  const history = useHistory();

  const handlePayClick = () => {
    history.push({
      pathname: '/payment-page',
      state: { totalAmount: totalAmount, selectedPayments: selectedPayments }
    });
  };

  console.log(totalAmount, selectedPayments);

  // View modal footer with close button
  const viewModalFooter = (
    <div className="flex justify-end">
      <button
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
        onClick={handleCloseModal}
      >
        Close
      </button>
    </div>
  );

  return (
    <div className="bg-gray-50 min-h-screen md:p-4">
      {loading && <Loading />}
      {!loading && (
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Payments Details</h1>
          </div>

          <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
            <div className="flex border-b border-gray-200">
              <button
                className={`px-5 py-4 text-center cursor-pointer border-b-2 ${activeTab === 'Pending'
                  ? 'border-blue-500 text-blue-600 font-medium'
                  : 'border-transparent text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                  }`}
                onClick={() => setActiveTab('Pending')}
              >
                Pending Payments
              </button>
              <button
                className={`px-5 py-4 text-center cursor-pointer border-b-2 ${activeTab === 'Successfully'
                  ? 'border-blue-500 text-blue-600 font-medium'
                  : 'border-transparent text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                  }`}
                onClick={() => setActiveTab('Successfully')}
              >
                Payment History
              </button>
            </div>

            <div className="w-full">
              <div className="flex flex-col sm:flex-col md:flex-row lg:flex-row items-center justify-between p-4 gap-2.5">
                <div className="relative w-full md:w-64 mb-4 md:mb-0">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Search className="h-5 w-5 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    id="searchName"
                    placeholder="Search by Name"
                    value={searchQuery}
                    onChange={handleSearch}
                    className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="flex flex-wrap items-center gap-2 w-full md:w-auto md:justify-end">
                  <div className="flex gap-2 w-full md:w-auto">
                    <input
                      type="date"
                      name="startDates"
                      value={filterData.startDates}
                      onChange={handleStartDateChange}
                      className="px-3 py-[11px] border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-auto"
                    />
                    <input
                      type="date"
                      name="endDates"
                      value={filterData.endDates}
                      onChange={(event) => handleEndDateChange(event)}
                      className="px-3 py-[11px] border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-auto"
                    />
                  </div>
                  <div className="w-full md:w-auto">
                    <select
                      name="paymentType"
                      id="paymentType"
                      value={filterData.filterType}
                      onChange={handlePaymentStatusChange}
                      className="px-3 py-[11px] border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-auto cursor-pointer"
                    >
                      <option value="">Select Payment</option>
                      <option value="AmenityBooking">Amenity Booking</option>
                      <option value="MonthlyRevenue">Monthly Revenue</option>
                      <option value="ServiceRequest">Service Request</option>
                      <option value="Violation">Violation</option>
                    </select>
                  </div>
                  <div className="flex gap-2 w-full md:w-auto">
                    <button
                      onClick={handleSearchChange}
                      className="px-4 py-[11px] bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm cursor-pointer w-full md:w-auto"
                    >
                      Search
                    </button>

                    {clearBtnshow && (
                      <button
                        onClick={clearFilters}
                        className="px-4 py-[11px] bg-gray-500 text-white rounded-md hover:bg-gray-600 text-sm cursor-pointer w-full md:w-auto"
                        title="Clear Filter"
                      >
                        Clear
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {activeTab === 'Pending' ? (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-blue-400">
                      <tr>
                        {(roleId === 1003) && (
                          <th className="px-6 py-3 text-sm font-medium text-white tracking-wider text-left">Select</th>
                        )}
                        {(roleId === 1001 || roleId === 1002) && (
                          <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Client Name</th>
                        )}
                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Payment For</th>
                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Created Date</th>
                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">$ Amount</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {paginatedData.length === 0 ? (
                        <tr>
                          <td colSpan={roleId === 1003 ? "4" : "4"} className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                        </tr>
                      ) : paginatedData.map((item, index) => (
                        <tr key={item.paymentDetailId} className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}>
                          {(roleId === 1003) && (
                            <td className="px-6 py-4 whitespace-nowrap ">
                              <div className="flex items-start">
                                <input
                                  type="checkbox"
                                  checked={selectedPayments.includes(item)}
                                  onChange={() => handleCheckboxChange(item)}
                                  className="rounded text-blue-500 focus:ring-blue-500 cursor-pointer"
                                />
                              </div>
                            </td>
                          )}
                          {(roleId === 1001 || roleId === 1002) && (
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.clientName}</td>
                          )}
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.reason}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">
                            {new Date(item.createdDate).toLocaleDateString('en-IN')}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">${item.amount}.00</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-blue-400">
                      <tr>
                        {(roleId === 1001 || roleId === 1002 || roleId === 1003) && (
                          <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Client Name</th>
                        )}
                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Payment For</th>
                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Bank Name</th>
                        <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Payment Date</th>
                        <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">$ Amount</th>
                        <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Payment Status</th>
                        <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">View more</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {paginatedData.length === 0 ? (
                        <tr>
                          <td colSpan={roleId === 1000 || roleId === 1001 ? "7" : "6"} className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                        </tr>
                      ) : paginatedData.map((item, index) => (
                        <tr key={item.paymentDetailId} className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.clientName}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.reason}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.paymentBank}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                            {new Date(item.paymentDate).toLocaleDateString('en-IN')}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">${item.amount}.00</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">{item.paymentStatus}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                            <button
                              className="text-blue-500 hover:text-blue-700"
                              onClick={() => handleViewMore(item.paymentDetailId)}
                              title="View More"
                            >
                              <Eye size={18} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {selectedPayments.length > 0 && activeTab === 'Pending' && (
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                  <div className="flex flex-wrap justify-between items-center gap-4">
                    <h4 className="font-medium text-gray-800">Total Amount: <span className="font-bold">${totalAmount.toFixed(2)}</span></h4>
                    <Link to="/payment-page">
                      <button
                        type="submit"
                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                        onClick={handlePayClick}
                      >
                        Pay Now
                      </button>
                    </Link>
                  </div>
                </div>
              )}

              <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                <div className="text-sm text-gray-700">
                  Page {currentPage + 1} of {pageCount > 0 ? pageCount : 1}
                </div>
                <div className="flex-1 flex justify-end">
                  <Pagination
                    currentPage={currentPage}
                    pageCount={pageCount}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Payment Details Modal using GlassmorphicModal */}
          <GlassmorphicModal
            isOpen={showCommunityForm}
            onClose={handleCloseModal}
            title="Payment Details"
            size="lg"
            footer={viewModalFooter}
          >
            {selectedPayment && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Client Name</label>
                  <input
                    type="text"
                    value={selectedPayment.clientName}
                    readOnly
                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Reason</label>
                  <input
                    type="text"
                    value={selectedPayment.reason}
                    readOnly
                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Payment Method</label>
                  <input
                    type="text"
                    value={selectedPayment.paymentMethod}
                    readOnly
                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Bank Name</label>
                  <input
                    type="text"
                    value={selectedPayment.paymentBank}
                    readOnly
                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Payment Status</label>
                  <input
                    type="text"
                    value={selectedPayment.paymentStatus}
                    readOnly
                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
                  <input
                    type="text"
                    value={selectedPayment.amount}
                    readOnly
                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                  />
                </div>
              </div>
            )}
          </GlassmorphicModal>
        </div>
      )}
    </div>
  );
};

export default PaymentsDetails;